// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aUpE","iconWrapper":"styles_iconWrapper__2IT0G"};